import React from "react";
import { Mutation } from "react-apollo";
import AdUnitsForm from "../components/form";

import {
  ADD_AD_UNIT,
  FIND_ADUNITS_BY_PLUBLISHERID_DYNAMIC,
  FIND_ADUNITS_DOMAINS,
} from "../../../queries/adUnit";

const Add = props => {
  return (
    <Mutation
      mutation={ADD_AD_UNIT}
      update={(store, { data: { createAdUnit } }) => {
        const { findAdUnitsByPublisherId } = store.readQuery({
          query: FIND_ADUNITS_BY_PLUBLISHERID_DYNAMIC(createAdUnit.publisherId),
        });
        store.writeQuery({
          query: FIND_ADUNITS_BY_PLUBLISHERID_DYNAMIC(createAdUnit.publisherId),
          data: {
            findAdUnitsByPublisherId: findAdUnitsByPublisherId.concat([
              createAdUnit,
            ]),
          },
        });
      }}
      refetchQueries={[{ query: FIND_ADUNITS_DOMAINS }]}
      awaitRefetchQueries={true}
    >
      {createAdUnit => <AdUnitsForm query_f={createAdUnit} {...props} />}
    </Mutation>
  );
};

export default Add;
